import { useContext } from "react"
import { CallContext } from "./call.context";

export const useCall = () => {
    const context = useContext(CallContext)
    if (context === undefined){
        throw new Error(`Component is not inside CallContext scope`);
    }
    return context
}